import AOS from 'aos';
import 'aos/dist/aos.css';
import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import '../Pages/style.css';

import Image1 from '../Images/home2.png';
import Image2 from '../Images/home1.jpg';
import Image3 from '../Images/home3.jpg';
import Image4 from '../Images/home4.jpg';
import WhatsNewImage from '../Images/doctor.jpg';
import Product2 from '../Images/ecg18.jpeg';
import Product3 from '../Images/ctg.jpeg';
import Product4 from '../Images/multiparamonitor.jpeg';
import Product5 from '../Images/USG.jpg';
import Product6 from '../Images/pulsefinger.jpeg';
import Footer from '../Pages/Footer';

const Home = () => {
  const images = [Image1, Image2, Image3, Image4];

  const [currentIndex, setCurrentIndex] = useState(0);

  const navigate = useNavigate();
  const isMobile = window.innerWidth <= 768;
  const scrollRef = useRef(null);

  const products = [
    {
      id: 1,
      name: 'MT ECG 180',
      subtitle: '18 Channel ECG Machine',
      image: Product2,
      description:
        'High-performance touch screen ECG machine with advanced recording and wireless connectivity.',
      path: '/products/ecg',
    },
    {
      id: 2,
      name: 'MM CD 100',
      subtitle: 'Color Dopplers & Ultrasound',
      image: Product5,
      description:
        'High resolution imaging for accurate diagnostics, supporting multiple probe performance.',
      path: '/products/portableultrasoundmachine',
    },
    {
      id: 3,
      name: 'CTG Monitor',
      subtitle: 'Cardiotocography',
      image: Product3,
      description:
        'Continuous fetal heart rate and uterine contraction monitoring for safe obstetrics.',
      path: '/products/cardiotocography',
    },
    {
      id: 4,
      name: 'Multipara Monitor',
      subtitle: 'Multiparameter Monitor',
      image: Product4,
      description:
        'Real-time monitoring with advanced patient parameters and alarm management.',
      path: '/products/multiparamonitor',
    },
    {
      id: 5,
      name: 'Pulse Oximeter',
      subtitle: 'Fingertip SpO₂ Monitor',
      image: Product6,
      description:
        'Accurate SpO₂ and pulse rate monitoring in a compact, easy-to-use device.',
      path: '/products/pulseoximeter',
    },
  ];

  const insights = [
    {
      number: '01',
      text:
        'As ISO-certified, CE-marked, CDSCO-approved, and DPIIT recognized, Mindron adheres to international standards that apply to quality, safety, performance, and innovation. Our ISO certification is a recognition of our dedication to provide you reliable medical equipment and take utmost responsibility in respect of healthcare professionals and patients.',
    },
    {
      number: '02',
      text:
        "We investigate innovative technologies and solutions that will play an increasingly important role in the healthcare sector in the near future. We pursue innovations in researching, developing products, and testing them for efficiency and dependability for use in today's healthcare facilities.",
    },
    {
      number: '03',
      text:
        'Keep up-to-date on new advancements in the med tech industry in terms of healthcare policy changes, technological advancements, diagnostic equipment, quality standards, etc. Mindron Insights informs healthcare professionals of the latest industry news and knowledge.',
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [images.length]);

  useEffect(() => {
    AOS.init({ duration: 1000, once: false });
  }, []);

  useEffect(() => {
    document.body.style.overflowX = 'hidden';

    return () => {
      document.body.style.overflowX = 'auto';
    };
  }, []);

  const scrollLeft = () =>
    scrollRef.current?.scrollBy({ left: -340, behavior: 'smooth' });

  const scrollRight = () =>
    scrollRef.current?.scrollBy({ left: 340, behavior: 'smooth' });

  const headerStyle = {
    position: 'relative',
    width: '100%',
    height: isMobile ? 'auto' : '90vh',
    overflow: 'hidden',
    minHeight: isMobile ? 'auto' : '400px',
    maxHeight: '100vh',
  };

  const indicatorStyle = (active) => ({
    width: '30px',
    height: '4px',
    backgroundColor: active ? 'red' : '#ccc',
    borderRadius: '2px',
    cursor: 'pointer',
    transition: 'background-color 0.3s',
  });

  return (
    <>
      <Helmet>
        <title>
          Mindron Meditech Pvt. Ltd. | Medical Devices & Diagnostic Solutions
        </title>
        <meta
          name="description"
          content="Mindron Meditech Pvt. Ltd. is a Mumbai-based medical device company offering advanced diagnostic and healthcare solutions including ECG machines, multipara monitors, ultrasound machines, CTG monitors, pulse oximeters, and more."
        />
        <link rel="canonical" href="https://www.mindronmeditech.com/" />
      </Helmet>

      <div style={{ position: 'relative', overflow: 'hidden' }}>
        {/* ── HERO SLIDER ── */}
        <div className="header-container" style={headerStyle}>
          <img
            src={images[currentIndex]}
            alt={`Slide ${currentIndex + 1}`}
            style={{
              width: '100%',
              height: isMobile ? 'auto' : '100vh',
              objectFit: 'cover',
              display: 'block',
            }}
          />

          {/* Dot indicators */}
          <div
            style={{
              position: 'absolute',
              bottom: '15px',
              left: '50%',
              transform: 'translateX(-50%)',
              display: 'flex',
              gap: '10px',
              zIndex: 2,
            }}
          >
            {images.map((_, index) => (
              <div
                key={index}
                style={indicatorStyle(index === currentIndex)}
                onClick={() => setCurrentIndex(index)}
              />
            ))}
          </div>
        </div>

        {/* ── ABOUT US SECTION ── */}
        <div
          style={{
            padding: isMobile ? '40px 6%' : '56px 5%',
            background: '#fff',
          }}
        >
          {/* Underline + Heading */}
          <div
            style={{
              width: '50px',
              height: '5px',
              backgroundColor: 'red',
              borderRadius: '2px',
              marginBottom: '12px',
            }}
          />

          <h2
            style={{
              fontSize: '24px',
              fontWeight: '800',
              color: '#0a1628',
              marginBottom: '24px',
            }}
          >
            About us
          </h2>

          {/* Image + Text row */}
          <div
            style={{
              display: 'flex',
              flexWrap: isMobile ? 'wrap' : 'nowrap',
              gap: '0',
            }}
          >
            {/* Left: image */}
            <div
              data-aos="fade-right"
              style={{
                flex: '1 1 45%',
                minWidth: isMobile ? '100%' : '280px',
                order: 1,
              }}
            >
              <img
                src={WhatsNewImage}
                alt="About Us"
                style={{
                  width: '100%',
                  height: '420px',
                  objectFit: 'cover',
                  objectPosition: 'top',
                  display: 'block',
                  borderRadius: '10px',
                }}
              />
            </div>

            {/* Right: text */}
            <div
              data-aos="fade-left"
              style={{
                flex: '1 1 45%',
                minWidth: isMobile ? '100%' : '280px',
                background: '#f7f9fc',
                padding: isMobile ? '32px 6%' : '48px 6%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                order: 2,
              }}
            >
              <h2
                style={{
                  fontSize: isMobile ? '26px' : '34px',
                  fontWeight: '800',
                  color: '#0a1628',
                  lineHeight: '1.2',
                  marginBottom: '20px',
                }}
              >
                Mindron Meditech Pvt. Ltd. is a Mumbai-based medical device
                company.
              </h2>

              <p
                style={{
                  fontSize: '15px',
                  color: '#555',
                  lineHeight: '1.8',
                  marginBottom: '16px',
                }}
              >
                It is dedicated to developing dependable diagnostic solutions
                for modern healthcare environments. Our focus is on enhancing
                accuracy and accessibility through technology that integrates
                smoothly into everyday clinical workflows.
              </p>

              <button
                style={{
                  alignSelf: 'flex-start',
                  marginTop: '8px',
                  padding: '10px 24px',
                  backgroundColor: '#001F54',
                  color: '#fff',
                  border: '2px solid #001F54',
                  borderRadius: '5px',
                  fontSize: '14px',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#fff';
                  e.target.style.color = '#001F54';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = '#001F54';
                  e.target.style.color = '#fff';
                }}
                onClick={() => navigate('/about')}
              >
                Explore More
              </button>
            </div>
          </div>
        </div>

        {/* ── MINDRON INSIGHTS ── */}
        <div
          style={{
            padding: isMobile ? '40px 6%' : '56px 5%',
            background: '#fff',
          }}
        >
          <div
            style={{
              width: '50px',
              height: '5px',
              backgroundColor: 'red',
              borderRadius: '2px',
              marginBottom: '12px',
            }}
          />

          <h2
            style={{
              fontSize: '24px',
              fontWeight: '800',
              color: '#0a1628',
              marginBottom: '28px',
            }}
          >
            Mindron Insights
          </h2>

          <div
            style={{
              display: 'grid',
              gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)',
              gap: '20px',
            }}
          >
            {insights.map((item, i) => (
              <div
                key={i}
                data-aos="fade-up"
                data-aos-delay={i * 100}
                style={{
                  background: '#f0f4ff',
                  borderRadius: '10px',
                  padding: '24px 20px',
                }}
              >
                <div
                  style={{
                    fontSize: '28px',
                    fontWeight: '800',
                    color: '#003366',
                    marginBottom: '14px',
                  }}
                >
                  {item.number}
                </div>

                <p
                  style={{
                    fontSize: '14px',
                    color: '#444',
                    lineHeight: '1.7',
                    margin: 0,
                  }}
                >
                  {item.text}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* ── PRODUCTS SECTION ── */}
        <div
          style={{
            padding: isMobile ? '40px 6%' : '50px 5%',
            background: '#fff',
          }}
          data-aos="fade-up"
        >
          {/* Heading row */}
          <div style={{ marginBottom: '8px' }}>
            <div
              style={{
                width: '50px',
                height: '5px',
                backgroundColor: 'red',
                borderRadius: '2px',
                marginBottom: '10px',
              }}
            />

            <h2
              style={{
                fontSize: '26px',
                fontWeight: '800',
                color: '#0a1628',
                margin: '0 0 6px',
              }}
            >
              Product
            </h2>

            <p
              style={{
                fontSize: '20px',
                color: '#666',
                margin: '0 0 24px',
                maxWidth: '700px',
              }}
            >
              Explore Mindron Meditech&apos;s advanced medical solutions,
              crafted to make healthcare safer, smarter, and more accessible.
              Our innovations empower medical professionals, enhance patient
              care, and drive the future of healthcare through precision,
              reliability, and a commitment to excellence.
            </p>

            <button
              style={{
                padding: '10px 24px',
                backgroundColor: '#001F54',
                color: '#fff',
                border: '2px solid #001F54',
                borderRadius: '5px',
                fontSize: '14px',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                marginBottom: '28px',
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#fff';
                e.target.style.color = '#001F54';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = '#001F54';
                e.target.style.color = '#fff';
              }}
              onClick={() => navigate('/product')}
            >
              Explore More
            </button>
          </div>

          {/* Scrollable product cards */}
          <div style={{ position: 'relative' }}>
            {/* Left Arrow */}
            {/* <button onClick={scrollLeft} style={{
              position: 'absolute', top: '50%', left: '-16px',
              transform: 'translateY(-50%)', zIndex: 10,
              backgroundColor: '#fff', border: 'none', borderRadius: '50%',
              width: '36px', height: '36px', cursor: 'pointer',
              boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
            }}>◀</button> */}

            <div
              ref={scrollRef}
              style={{
                display: 'flex',
                gap: '20px',
                overflowX: 'auto',
                scrollSnapType: 'x mandatory',
                scrollbarWidth: 'none',
                msOverflowStyle: 'none',
                padding: '4px 2px',
              }}
            >
              {products.map((product) => (
                <div
                  key={product.id}
                  onClick={() => navigate(product.path)}
                  style={{
                    flex: '0 0 auto',
                    width: isMobile ? '260px' : '400px',
                    minHeight: isMobile ? '140px' : '200px',
                    scrollSnapAlign: 'start',
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    gap: '16px',
                    background: '#f4f6fb',
                    borderRadius: '12px',
                    padding: '20px 16px',
                    cursor: 'pointer',
                    transition: 'transform 0.2s, box-shadow 0.2s',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-4px)';
                    e.currentTarget.style.boxShadow =
                      '0 8px 20px rgba(0,0,0,0.12)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow =
                      '0 2px 8px rgba(0,0,0,0.06)';
                  }}
                >
                  {/* Left: text */}
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div
                      style={{
                        fontSize: '11px',
                        color: '#1a56db',
                        fontWeight: '600',
                        marginBottom: '4px',
                      }}
                    >
                      {product.subtitle}
                    </div>

                    <h3
                      style={{
                        fontSize: isMobile ? '15px' : '20px',
                        fontWeight: '900',
                        color: '#0a1628',
                        margin: '0 0 8px',
                        whiteSpace: 'normal',
                      }}
                    >
                      {product.name}
                    </h3>

                    <p
                      style={{
                        fontSize: isMobile ? '12px' : '16px',
                        color: '#666',
                        lineHeight: '1.6',
                        margin: 0,
                        whiteSpace: 'normal',
                      }}
                    >
                      {product.description}
                    </p>
                  </div>

                  {/* Right: image */}
                  <img
                    src={product.image}
                    alt={product.name}
                    style={{
                      width: isMobile ? '80px' : '150px',
                      height: isMobile ? '90px' : '150px',
                      objectFit: 'contain',
                      flexShrink: 0,
                      borderRadius: '8px',
                    }}
                  />
                </div>
              ))}
            </div>

            {/* Right Arrow
            <button onClick={scrollRight} style={{
              position: 'absolute', top: '50%', right: '-16px',
              transform: 'translateY(-50%)', zIndex: 10,
              backgroundColor: '#fff', border: 'none', borderRadius: '50%',
              width: '36px', height: '36px', cursor: 'pointer',
              boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
            }}>▶</button> */}
          </div>
        </div>

        <style>{`
          @media (max-width: 768px) {
            .header-container {
              height: 30vh !important;
            }
          }

          div::-webkit-scrollbar {
            display: none;
          }
        `}</style>

        <Footer />
      </div>
    </>
  );
};

export default Home;